import { API_CALL_ERROR } from '../../../store/action';
import { AppInjector } from '../../../app-injector';
import { takeEvery, put, takeLatest } from 'redux-saga/effects';
import {
  LOGIN_REQUESTED,
  LOGIN_SUCCEEDED,
  FETCH_LOGIN_DETAIL_REQUESTED,
  FETCH_LOGIN_DETAIL_SUCCEEDED,
  LOGOUT_REQUESTED
} from './login.actions';
import { ApiUrl } from '../../../api/api-url.service';
import { ApiService } from '../../../api/api.service';
import * as Cookies from 'js-cookie';
import { environment } from '../../../../environments/environment';
import { NotificationService } from '../../../common/services/notification/notification.service';
import * as _ from 'lodash';
import {AuthService} from "../../../auth/auth.service";

function* login(action) {
  try {
    const api = AppInjector.get(ApiService);
    let result = yield api.auth.login(action.data).toPromise();
    yield put({ type: LOGIN_SUCCEEDED, data: result.data });
  } catch (e) {
    yield put({ type: API_CALL_ERROR, error: e });
  }
}

function* watchLoginRequest() {
  yield takeEvery(LOGIN_REQUESTED, login);
}

function* login_success(action) {
  Cookies.set(environment.jwtTokenKey, action.data.access_token, { path: '/' });
  yield put({ type: FETCH_LOGIN_DETAIL_REQUESTED, com: 'LOGIN_COMPONENT' });
}

function* watchLoginSUCCEEDED() {
  yield takeLatest(LOGIN_SUCCEEDED, login_success);
}

function* redirect(action) {
  if (!_.isUndefined(action.com) && action.com === 'LOGIN_COMPONENT') {
    const authService = AppInjector.get(AuthService);
    authService.redirectUrl();
  }
}

function* watchFetchLoginDetailSUCCEEDED() {
  yield takeLatest(FETCH_LOGIN_DETAIL_SUCCEEDED, redirect);
}

function* fetchProfileDetail(action) {
  try {
    const api = AppInjector.get(ApiService);
    let result = yield api.user.profile({ includes: 'roles' }).toPromise();
    AppInjector.get(NotificationService).show('success', 'Login Success', 5000);
    if (!_.isUndefined(action.com)) {
      yield put({ type: FETCH_LOGIN_DETAIL_SUCCEEDED, data: result, com: action.com });
    } else {
      yield put({ type: FETCH_LOGIN_DETAIL_SUCCEEDED, data: result });
    }
  } catch (e) {
    yield put({ type: API_CALL_ERROR, error: e });
  }
}

function* watchFetchProfileRequest() {
  yield takeLatest(FETCH_LOGIN_DETAIL_REQUESTED, fetchProfileDetail);
}

function* logout(action) {
  const authService = AppInjector.get(AuthService);
  authService.logout();
}

function* watchLogout() {
  yield takeLatest(LOGOUT_REQUESTED, logout);
}

function* jwtError(action) {
  if (action.error && action.error.error) {
    let err =  action.error.error;
    let fullMessage = err.full ? err.full : '';
    if (fullMessage.indexOf('AbstractTokenException') > '-1') {
      AppInjector.get(NotificationService).show('success', 'Session expired', 5000);
      yield put({ type: LOGOUT_REQUESTED });
    }
  }
}

function* watchJwtError() {
  yield takeEvery(API_CALL_ERROR, jwtError);
}

export default [watchLoginRequest, watchLoginSUCCEEDED, watchFetchLoginDetailSUCCEEDED, watchFetchProfileRequest, watchJwtError, watchLogout];

